import { render, staticRenderFns } from "./teacherTopPage.vue?vue&type=template&id=5d8cf74f&scoped=true&"
import script from "./teacherTopPage.vue?vue&type=script&lang=js&"
export * from "./teacherTopPage.vue?vue&type=script&lang=js&"
import style0 from "./teacherTopPage.vue?vue&type=style&index=0&id=5d8cf74f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8cf74f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d8cf74f')) {
      api.createRecord('5d8cf74f', component.options)
    } else {
      api.reload('5d8cf74f', component.options)
    }
    module.hot.accept("./teacherTopPage.vue?vue&type=template&id=5d8cf74f&scoped=true&", function () {
      api.rerender('5d8cf74f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/zxx/components/home-page/teacherTopPage.vue"
export default component.exports